"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _Logger = _interopRequireDefault(require("../Logger"));
var _Registration = _interopRequireDefault(require("../Registration"));
var _Container = _interopRequireDefault(require("../Container"));
var _ReactDomFactory = _interopRequireDefault(require("../factories/ReactDomFactory"));
/**
 * Copyright 2016-present, Deloitte Digital.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-3-Clause license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ContainerBuilder = /*#__PURE__*/function () {
  function ContainerBuilder() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    (0, _classCallCheck2.default)(this, ContainerBuilder);
    this._registrations = [];
    this._defaultOptions = options;
    this._factory = _ReactDomFactory.default;
  }

  /**
   * Register new component asynchronously
   * @param {Function}        operator    - function that returns a promise that resolves a React Component
   * @returns {Registration}
   */
  (0, _createClass2.default)(ContainerBuilder, [{
    key: "registerAsync",
    value: function registerAsync(operator) {
      var registration = new _Registration.default(operator);
      if (this._defaultOptions) {
        registration.withOptions(this._defaultOptions);
      }
      this._registrations.push(registration);
      return registration;
    }

    /**
     * Register new component
     * @param {object}        component    - a React Component to register
     * @returns {Registration}
     */
  }, {
    key: "register",
    value: function register(component) {
      return this.registerAsync(function () {
        return Promise.resolve(component);
      });
    }

    /**
     * Set the container factory
     * @param {Object}  factory - The factory
     */
  }, {
    key: "factory",
    set: function set(factory) {
      this._factory = factory;
    }

    /**
     * Build the container
     * @returns {Container}
     */
  }, {
    key: "build",
    value: function build() {
      return new _Container.default(this._factory, this._registrations.reduce(function (acc, registration) {
        if (!registration.key) {
          _Logger.default.error('RHE11', 'Missing key for registration.');
          return acc;
        }
        if (acc[registration.key]) {
          _Logger.default.warn('RHW12', 'Duplicate key', registration.key);
        }
        acc[registration.key] = registration;
        return acc;
      }, {}));
    }
  }]);
  return ContainerBuilder;
}();
exports.default = ContainerBuilder;